"use client";

import { useEffect } from 'react';

export function HydrationFix() {
  useEffect(() => {
    // Remove any attributes that might be added by browser extensions
    // that could cause hydration mismatches
    const body = document.body;
    
    // Remove common extension attributes that cause hydration issues
    const extensionAttributes = [
      'cz-shortcut-listen',
      'data-new-gr-c-s-check-loaded',
      'data-gr-ext-installed',
      'data-grammarly-shadow-root',
      'data-grammarly-ignore',
      'data-grammarly-ignore-all'
    ];
    
    extensionAttributes.forEach(attr => {
      if (body.hasAttribute(attr)) {
        body.removeAttribute(attr);
      }
    });
    
    // Also check for any dynamically added attributes on the html element
    const html = document.documentElement;
    extensionAttributes.forEach(attr => {
      if (html.hasAttribute(attr)) {
        html.removeAttribute(attr);
      }
    });
  }, []);

  return null;
}





